import { isEmpty } from "@swiggy-private/js-utils";
import { WidgetTypes } from "@swiggy-private/dls-react-mxn/dist/WidgetController/constants";
import { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { ICardsEntity } from "@swiggy-private/dls-react-mxn/dist/WidgetController/type";
import { IDineoutMenuHeaderProps } from "@swiggy-private/dls-react-mxn/dist/WidgetController/widgets/DineoutMenuHeader/types";

export const getRestaurantName = (cards: IPLWidgetControllerCards[]) => {
    if (!isEmpty(cards)) {
        const mastheadCard = cards?.find((card) => {
            if (
                (card?.card?.card as keyof ICardsEntity)?.["@type"] ===
                WidgetTypes.DINEOUT_MENU_HEADER
            )
                return card;
        });

        const restaurantInfo = mastheadCard?.card.card as IDineoutMenuHeaderProps;
        return restaurantInfo.info?.name ?? "";
    }

    return "";
};

export const noop = () => void 0;
